import React from 'react';
import cn from 'classnames';
import MainAccceptanceFieldsCol from '../../../../../presenters/MainAcceptanceFieldsCol';
import SelectedAddressesCol from './SelectedAddressesCol';
import SetupDesks from '../../../../../presenters/SetupDesks';
import styles from './index.module.scss';

const AcceptanceSetup = ({ className }) => {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.leftCol}>
        <MainAccceptanceFieldsCol />
        <SelectedAddressesCol className={styles.selectedAddressCol} />
      </div>
      <SetupDesks allowClearClassicTime />
    </div>
  );
};

export default AcceptanceSetup;
